<template>
    <div class="contract-manage-iflow-table">
        <table-box v-loading="subTabTable.tableLoading" :selection="TABLECONFIG.selection"
            :columns="TABLECONFIG.columns" :height="tableHeight" :actions="TABLECONFIG.actions"
            :rows="subTabTable.totalData">
        </table-box>
        <div class="footer">
            <lots-pagination @size-change='subTabTable.sizeChange' :current-page.sync='subTabTable.pageNo'
                @current-change='subTabTable.pageChange' size="small" layout='total, sizes, prev, pager, next, jumper'
                :total='subTabTable.pageTotal' />
        </div>
    </div>
</template>

<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getDictDataApi, getContractInfoAuthList } from '@mdm/api/contractManage/contractListApi.js';
import { ref, watch, computed, reactive } from '@vue/composition-api';
import { tableConfig } from './config.js';
import tableBox from '@/components/lots/tableBox/Index';
export default {
    components: {
        lotsPagination, tableBox
    },
    emits: [''],
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: { // 表格操作信息，不传默认为空
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        // eslint-disable-next-line complexity
        const TABLECONFIG = computed(() => {
            return config;
        });
        class IflowTalbeClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.customerCode = props.detailData.customerCode;
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    subTabTable.totalData.value = res.data.list.map(v => {
                        const busiList = v.businessType ? v.businessType.split(',') : [];
                        const busiLabelList = busiList.map(v2 => busiTypeList.value[v2]);
                        v.businessTypeCn = busiLabelList.join();
                        return v;
                    });
                    subTabTable.pageTotal.value = res.data.totalCount;
                }
            }
        };
        const subTabTable = new IflowTalbeClass({
            Api: {
                listApi: getContractInfoAuthList
            }
        });
        const busiTypeList = ref({});
        const getDictData = async () => {
            const dictData = await getDictDataApi({ dictCodes: 'SYS_BMS_BUSI_TYPE' });
            busiTypeList.value = dictData.data['SYS_BMS_BUSI_TYPE'];
        };
        watch(
            () => [props.activeName, props.detailData, props.detailData.contractChangeCode],
            async (newVal, oldVal) => {
                if (newVal[0] === 'contract' && newVal[1].customerCode) {
                    await getDictData();
                    subTabTable.getList();
                } else if (!newVal[1].customerCode) {
                    subTabTable.totalData.value = [];
                    subTabTable.pageTotal.value = 0;
                }
            }
        );

        return {
            config,
            TABLECONFIG,
            subTabTable
        };
    }
};
</script>
<style lang='less'>
.contract-manage-iflow-table {

    // margin-top: 15px;
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .mip-page-link {
        color: #4285f5;
        cursor: pointer;

        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
